var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wout-login"},[_c('div',{staticClass:"center"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/pgtoaprovado.svg"),"width":"auto","height":"130","alt":"Pagamento aprovado!","crossorigin":""}})]),_c('span',{staticClass:"aprovado"},[_vm._v("Pagamento aprovado!")])])])
}]

export { render, staticRenderFns }